import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@fgb/core';
import { ErrorStateService } from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { gsap } from 'gsap';

@Component({
  selector: 'fgb-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit {
  partnerDisabled: boolean = false;
  private _destroyed$ = new Subject<void>();
  private mm = gsap.matchMedia();

  constructor(
    private router: Router,
    public errorService: ErrorStateService,
    private authService: AuthService,
    private translate: TranslateService
  ) {
    if (this.authService.hasCurrentRefreshToken()) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.checkpartnerDisabledFlag();
    // Perform the background movement effect only for larger screens
    this.mm.add('screen and (min-width: 991px)', () => {
      const subscription = fromEvent(window, 'mousemove')
        .pipe(takeUntil(this._destroyed$))
        .subscribe((e: any) => {
          const target = e.target as Element | null;
          if (target && target.closest('.login-form')) {
            return;
          }

          const percentX = e.clientX / window.innerWidth;
          const percentY = e.clientY / window.innerHeight;

          const moveX = (percentX - 0.5) * 30;
          const moveY = (percentY - 0.5) * 30;

          gsap.to('.login-banner', {
            backgroundPosition: `${50 + moveX}% ${50 + moveY}%`,
            duration: 0.4,
            ease: 'power3.out',
          });
        });
      return () => {
        subscription.unsubscribe();
      };
    });
  }

  checkpartnerDisabledFlag() {
    this.translate
      .stream('partner.disabled.flag')
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: string) => {
        if (data === 'true') {
          this.partnerDisabled = JSON.parse(data);
        }
      });
  }
  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
